export const authChannel = new BroadcastChannel('auth')

export const triggerAuthChange = (): void => authChannel.postMessage('auth_change')

export const initAuthChangeListener = (): void => {
    authChannel.addEventListener('message', () => {
        window.location.reload()
    })
}
